import Overlay from '@components/overlays'

export default class Submenu extends Overlay {
    constructor(submenu) {
        super(submenu)

        this.triggers = document.querySelectorAll(`[aria-controls="${submenu.id}"]`)

        this.triggers[0].addEventListener('click', this.toggle)
        this.triggers[1].addEventListener('click', this.close)

        addEventListener('closesubmenus', this.close)
        addEventListener('click', e => {
            if(this.isOpened && !submenu.contains(e.target) && !e.target.closest(`[aria-controls="${submenu.id}"]`)) this.close()
        })
    }

    open() {
        document.body.classList.add('has-submenu')        
        
        super.open()
        
        this.triggers.forEach(trigger => {
            trigger.setAttribute('aria-expanded', true)
		})
    }

    close() {
        document.body.classList.remove('has-submenu')
        
        super.close()

        this.triggers.forEach(trigger => {
			trigger.setAttribute('aria-expanded', false)
		})
    }
}